var _a;
import Root from "./Root";
var base = "servisofts-model";
export default (_a = {},
    _a[base] = Root,
    _a);
